export const SWIMLANE_API_URI = '/rest/greenhopper/1.0/swimlanes';
export const UPDATE_SWIMLANE_STRATEGY_API_URI =
	'/rest/greenhopper/1.0/rapidviewconfig/swimlaneStrategy';
